import moment from "moment";
import { toast } from "react-toastify";

// Debounce
let timer;
export const debounce = (func, delay) => {
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, delay);
  };
};

export const validateEmail = (email) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email.toLowerCase()
  );

export const getFormattedDate = (date, format) =>
  date ? moment(date).format(format || "Do MMMM YYYY, h:mm A") : "N/A";

const getCollectionName = () => window.location.pathname.split("/")[1];

const DEFAULT_TABS_MAP = {
  default: {
    dashboard: [],
    user: [{ name: "Policy Management" }, { name: "Category Management" }],
  },
  seo: {
    dashboard: [{ name: "Analytics" }, { name: "Data Management" }],
    user: [{ name: "Policy Management" }, { name: "Category Management" }],
  },
  erp: {
    dashboard: [],
    user: [{ name: "Policy Management" }, { name: "Team Management" }],
  },
  bau: {
    dashboard: [],
    user: [{ name: "Policy Management" }],
  },
  uudesr: {
    dashboard: [],
    user: [{ name: "Policy Management" }],
  },
};

export const getDefaultTabs = () =>
  DEFAULT_TABS_MAP[getCollectionName()] || DEFAULT_TABS_MAP["default"];

export const deepClone = (obj) => {
  if (!obj || typeof obj !== "object") {
    return obj;
  }
  let newObj = {};
  if (Array.isArray(obj)) {
    newObj = obj.map((item) => deepClone(item));
  } else {
    Object.keys(obj).forEach((key) => {
      return (newObj[key] = deepClone(obj[key]));
    });
  }
  return newObj;
};

export const TABS_TYPE_MAP = {
  dashboard: "Dashboard",
  user: "User Management",
  task: "Task Management",
  approval: "Approval Management",
};

export const TINTY_MCE_EDITOR_CONFIG = {
  tinymceScriptSrc: process.env.PUBLIC_URL + "/tinymce/tinymce.min.js",
  init: {
    height: 300,
    menubar: false,
    plugins: [
      "image",
      "preview",
      "paste",
      "code",
      "help",
      "wordcount",
      "imagetools",
      "lists",
      "fullscreen",
      "directionality",
      "table",
      "link",
    ],
    toolbar:
      "undo redo | styleselect| link image | code | preview | numlist bullist | table ",
    content_style:
      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
    autoresize_on_init: false,
    file_picker_types: "image",

    file_picker_callback: (callback, value, meta) => {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");

      if (meta.filetype === "image") {
        input.click();
        input.onchange = async function () {
          const file = input?.files && input.files[0];
          callback(URL.createObjectURL(file));
        };
      }
    },

    max_height: 500,
    invalid_elements: "span",
    valid_styles: {
      "*": "",
    },
  },
};

//arguments type must be of array
//it will return a merged array without duplicates
export const mergeArrays = (...args) => {
  return [...new Set([].concat.apply([], args))];
};

//remove duplicate objects
export const removeDuplicateObjects = (array, property) => {
  const uniqueIds = [];

  return array.filter((element) =>
    uniqueIds.includes(element[property])
      ? false
      : !!uniqueIds.push(element[property])
  );
};

export const capitalize = (str) =>
  str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const COLLECTION_NAME = {
  CP: "cp",
  K8: "k8",
  TEV: "tev",
  DPP: "dpp",
  SEO: "seo",
  BAU: "bau",
  DESR: "uudesr",
};

export const copyToClipboard = (value) => {
  navigator.clipboard.writeText(value).then((res) => {
    toast.success("Copied to clipboard");
  });
};
export const getDeepValue = (keyPath, object) => {
  const keys = keyPath.split(".");
  const currentKey = keys.shift();

  if (currentKey !== undefined) {
    const currentValue = object[currentKey];

    if (keys.length === 0) {
      return typeof currentValue === "number"
        ? String(currentValue)
        : currentValue
        ? String(currentValue)
        : "";
    }

    if (currentValue && typeof currentValue === "object") {
      return getDeepValue(keys.join("."), currentValue);
    }
  }

  return "";
};
export const getValue = (field, values) =>
  field.length === 1
    ? typeof values[field[0]] === "number"
      ? values[field[0]].toString()
      : values[field[0]]
    : getValue(field.splice(1), values[field[0]]);

export const MESSAGE_KEYS_MAP = {
  TICKET_STATUS: "TICKET_STATUS",
  DEFAULT: "DEFAULT",
};
export const CONFIRMATION_MESSAGE_MAP = {
  [MESSAGE_KEYS_MAP.TICKET_STATUS]: `Are you sure that you want to set status for selected tickets? This action cannot be reverted.`,
  [MESSAGE_KEYS_MAP.TICKET_VERIFIVATION_STATUS]: `Are you sure that you want to send this issue back to manager? This action cannot be reverted.`,
  [MESSAGE_KEYS_MAP.DEFAULT]:
    "Are you sure that you want to proceed? This action cannot be reverted.",
};

export const DateToHours = ({ dateString, withoutComputing = false }) => {
  const now = moment(); // Current date and time
  const date = moment(dateString); // The date you want to convert

  // Calculate the difference in hours
  const hoursDifference = withoutComputing
    ? dateString
    : Math.abs(date.diff(now, "hours"));
  if (hoursDifference < 24) {
    return (
      <div>
        {hoursDifference} hour
        {hoursDifference > 1 || hoursDifference === 0 ? "s" : ""}
      </div>
    );
  } else if (hoursDifference < 24 * 30) {
    const daysDifference = Math.floor(hoursDifference / 24);
    return (
      <div>
        {daysDifference} day{daysDifference !== 1 ? "s" : ""}
      </div>
    );
  } else {
    const monthsDifference = Math.floor(hoursDifference / (24 * 30));
    return (
      <div>
        {monthsDifference} month{monthsDifference !== 1 ? "s" : ""}
      </div>
    );
  }
};
export const DateToHourNo = (dateString) => {
  const now = moment(); // Current date and time
  const date = moment(dateString); // The date you want to convert

  // Calculate the difference in hours
  const hoursDifference = Math.abs(date.diff(now, "hours"));
  return hoursDifference;
};
export const fileSizeValidation = (fileSize, maxLimit) => {
  return fileSize <= maxLimit;
};

export const getFileSize = (quantity, unit) => {
  let size = 0;
  switch (unit) {
    case "MB":
      size = quantity * 1024 * 1024;
      break;

    case "GB":
      size = quantity * 1024 * 1024 * 1024;
      break;

    default:
      size = quantity * 1024;
  }

  return size;
};

export const tranformFilterObj = (filterObj) => {
  let obj = deepClone(filterObj);
  if (Object.keys(obj).length !== 0) {
    obj.isFilter = true;
  }

  Object.keys(obj).forEach((key) => {
    let dataType = typeof obj[key];
    let objValue = obj[key];
    if (key === "deadline" && dataType === "object") {
      if ("From" in objValue && "To" in objValue) {
        obj.deadlineFrom = objValue.From;
        obj.deadlineTo = objValue.To;
        delete obj[key];
      }
    } else if (key === "pending" && dataType === "object") {
      if ("From" in objValue && "To" in objValue) {
        obj.pendingFrom = objValue.From;
        obj.pendingTo = objValue.To;
        delete obj[key];
      }
    }
  });
  return obj;
};

export const TEST_TYPE_FILTERS = [
  { name: "AIHybridEvaluation", id: "AIHybridEvaluation" },
];
